import { render, staticRenderFns } from "./GiftAnimationOverlay.vue?vue&type=template&id=07595a98&scoped=true"
import script from "./GiftAnimationOverlay.vue?vue&type=script&lang=js"
export * from "./GiftAnimationOverlay.vue?vue&type=script&lang=js"
import style0 from "./GiftAnimationOverlay.vue?vue&type=style&index=0&id=07595a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07595a98",
  null
  
)

export default component.exports